import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-role-of-interactive-flat-panels-in-remote-work',
  templateUrl: './role-of-interactive-flat-panels-in-remote-work.component.html',
  styleUrls: ['./role-of-interactive-flat-panels-in-remote-work.component.scss']
})
export class RoleOfInteractiveFlatPanelsInRemoteWorkComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('The Role of Interactive Flat Panels in Remote Work & Hybrid Collaboration | VIRSA');
    this.metaService.updateTag({ name: 'description', content: 'Discover how VIRSA Interactive Flat Panels improve remote work, hybrid meetings, online collaboration, virtual training, and digital communication for businesses and institutions.' });
    this.metaService.updateTag({ name: 'keywords', content: 'interactive flat panels for remote work, hybrid meeting solutions, interactive display for work from home, remote collaboration tools, VIRSA interactive flat panels, smart meeting room solutions' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
